export default {
  signIn: '/',
  resetPassword: '/password/reset',
  updatePassword: '/password/update/:token',
  trialCustomLabel: '/trial-custom-label',
  trialProductionCustomLabel: '/trial-production-custom-label',
  trial: '/trial',
  subscribe: '/subscribe',
  paymentConfirmation: '/paymentConfirmation',
  emailVerify: '/trials/email-verify/:token',
  terms: '/terms',
  dashboard: '/dashboard',
  palletDetails: '/pallet-details',
  barePallets: '/bare-pallets',
  barePalletCreate: '/bare-pallets/create',
  standaloneCases: '/standalone-cases',
  standaloneCaseCreate: '/standalone-cases/create',
  purchaseOrders: '/purchase-orders',
  purchaseOrderEnter: '/purchase-orders/enter',
  purchaseOrdersImport: '/purchase-orders/import',
  purchaseOrder: '/purchase-orders/view',
  purchaseOrderEdit: '/purchase-orders/edit',
  inventoryCreate: '/inventories/create',
  inventories: '/inventories',
  inventoryHistory: '/inventories/history',
  inventory: '/inventories/view',
  transfer: '/transfer',
  stockOnHand: '/stock-on-hand',
  bulkTransfer: '/bulk-transfer',
  licensePlates: '/license-plates',
  licensePlateUpload: '/license-plates/upload',
  userSubscriptions: '/profile-subscriptions',
  systemLabels: '/system-labels',
  customLabels: '/custom-labels',
  customLabel: '/custom-labels/view',
  customLabelPrintsPaginate: '/custom-labels/prints',
  customLabelPrint: '/custom-labels/print',
  customLabelCreate: '/custom-labels/create',
  customLabelEdit: '/custom-labels/edit',
  labelBuilder: '/label-builder',
  categories: '/categories',
  categoryCreate: '/categories/create',
  categoryEdit: '/categories/edit',
  locationCreate: '/locations/create',
  locationEdit: '/locations/edit',
  userCreate: '/users/create',
  userEdit: '/users/edit',
  items: '/items',
  itemCreate: '/items/create',
  itemEdit: '/items/edit',
  inventoryReport: '/report/inventory',
  shippingReport: '/report/shipping',
  packTraceReport: '/report/pack-trace',
  labelTraceReport: '/report/label-trace',
  labelTrace: '/label-trace',
  insAndOutsReport: '/report/ins-and-outs',
  workOrderCreate: '/work-orders/create',
  workOrder: '/work-orders/view',
  packTraceCreate: '/pack-traces/create',
  packTraces: '/pack-traces',
  packTrace: '/pack-traces/view',
  shipOrderPallets: '/ship-orders/pallets',
  users: '/users',
  locations: '/locations',
  locationSearch: '/locations/search',
  receivings: '/receivings',
  receivingCreate: '/receivings/create',
  workOrders: '/work-orders',
  workOrderCalendar: '/work-orders/calendar',
  workOrderEdit: '/work-orders/edit',
  ship: '/ship',
  shipOrders: '/ship-orders',
  shipOrderCreate: '/ship-orders/create',
  shipOrder: '/ship-orders/view',
  shipOrderEdit: '/ship-orders/edit',
  billsOfLading: '/bills-of-lading',
  billOfLadingGenerate: '/bills-of-lading/generate',
  caseTransfer: '/case-transfer',
  quantityTransfer: '/quantity-transfer',
  caseAssignment: '/case-assignment',
  contacts: '/contacts',
  contactCreate: '/contacts/create',
  contactEdit: '/contacts/edit',
  logout: '/logout'
}
